import DemoDayApplicationForm from "src/components/demo-day-application-form";
import * as React from 'react';
export default {
  DemoDayApplicationForm,
  React
};